/* eslint no-process-env: "off" */
const SELF_PROT = process.env.NEXT_PUBLIC_APP_SELF_PROT || "http";
const SELF_HOST = process.env.NEXT_PUBLIC_APP_SELF_HOST || "localhost";
const SELF_PORT = process.env.NEXT_PUBLIC_APP_SELF_PORT || "";
const SELF_BASE =
  process.env.NEXT_PUBLIC_APP_SELF_BASE
  || `${SELF_PROT}://${SELF_HOST}${SELF_PORT ? `:${SELF_PORT}` : ""}`;

const API_PROT = process.env.NEXT_APP_API_PROT || "http";
const API_HOST = process.env.NEXT_APP_API_HOST || "localhost";
const API_PORT = process.env.NEXT_APP_API_PORT || "";
const API_BASE =
  process.env.NEXT_APP_API_BASE
  || `${API_PROT}://${API_HOST}${API_PORT ? `:${API_PORT}` : ""}`;

const STORAGE_PROT = process.env.NEXT_APP_STORAGE_PROT || "http";
const STORAGE_HOST = process.env.NEXT_APP_STORAGE_HOST || "localhost";
const STORAGE_PORT = process.env.NEXT_APP_STORAGE_PORT || "";
const STORAGE_BUCKET = process.env.NEXT_APP_STORAGE_BUCKET || "maga";
const STORAGE_BASE =
  process.env.NEXT_APP_STORAGE_BASE
  || `${STORAGE_PROT}://${STORAGE_HOST}${STORAGE_PORT ? `:${STORAGE_PORT}` : ""}/${STORAGE_BUCKET}`;

const SUPAPOWAR_COOKIE = "ANCIENT_SUPAPOWAR";

module.exports = {
  SELF_PROT,
  SELF_HOST,
  SELF_PORT,
  SELF_BASE,
  API_PROT,
  API_HOST,
  API_PORT,
  API_BASE,
  STORAGE_PROT,
  STORAGE_HOST,
  STORAGE_PORT,
  STORAGE_BASE,
  SUPAPOWAR_COOKIE,
};
